"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoDescription = void 0;
const utils_1 = require("../utils");
exports.InfoDescription = () => {
    return {
        Info(info, ctx) {
            utils_1.validateDefinedAndNonEmpty('description', info, ctx);
        },
    };
};
